import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zh_CN from './zh_CN.json'
import zh_TW from './zh_tw.json'
import en from './en.json'
import ja from './ja.json'
import ar from './ar.json'
import bn_IN from './bn_IN.json'
import cs_CZ from './cs_CZ.json'
import de from './de.json'
import el_GR from './el_GR.json'
import es from './es.json'
import fa from './fa.json'
import fr from './fr.json'
import hi_IN from './hi_IN.json'
import hu_HU from './hu_HU.json'
import id from './id.json'
import it from './it.json'
import ko from './ko.json'
import ms_MY from './ms_MY.json'
import my_MM from './my_MM.json'
import nb from './nb.json'
import nl from './nl.json'
import pl from './pl.json'
import pt from './pt.json'
import ro from './ro.json'
import ru from './ru.json'
import sv_SE from './sv_SE.json'
import ta_IN from './ta_IN.json'
import te_IN from './te_IN.json'
import th from './th.json'
import tl_PH from './tl_PH.json'
import tr from './tr.json'
import vi from './vi.json'

Vue.use(VueI18n)

const messages = {
    zh_CN,
    zh_TW,
    en,
    ja,
    ar,
    bn_IN,
    cs_CZ,
    de,
    el_GR,
    es,
    fa,
    fr,
    hi_IN,
    hu_HU,
    id,
    it,
    ko,
    ms_MY,
    my_MM,
    nb,
    nl,
    pl,
    pt,
    ro,
    ru,
    sv_SE,
    ta_IN,
    te_IN,
    th,
    tl_PH,
    tr,
    vi
}

export default new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages
})